module.exports = __webpack_public_path__ + "290187cc1a9f6663fe0fa4782c0be897.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thesafezone/imac.jpg
// module id = 335
// module chunks = 1